import {handleLoading} from '../helpers/reduxHelpers';
import {settingsActionTypes as types} from 'actions/actionTypes';

const initialState = {
  settings: [],
  loading: {
    settings: true,
  },
};

export default function tax(state = initialState, action) {
  switch (action.type) {
    case types.SETTINGS.LOADING: {
      return {
        ...state,
        loading: handleLoading(state.loading, action),
      };
    }

    case types.SETTINGS.COMPLETE:
      return {
        ...state,
        loading: handleLoading(state.loading, {
          field: action.field,
          loading: false,
        }),
        [action.stateField]: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settingsReducer.js